(function(window, tabIndexFactory) {
   'use strict';

   var namespace = window.TSC = window.TSC || {};
   namespace.tabIndex = tabIndexFactory();
})(this, function() {
   'use strict';

   return {
      Disabled: -1,
      VideoWrapper: -1,
      QuestionReviewText: 0,
      HotspotView: 0,
      InitialPlay: 1,
      Progress: 2,
      Rewind: 3,
      Play: 4,
      Previous: 5,
      Next: 6,
      Volume: 7,
      VolumeSlider: 8,
      AudioDescription: 9,
      ClosedCaption: 10,
      TOC: 11,
      TOCSearch: 12,
      TOCErase: 16,
      TOCItem: 17,
      Settings: 18,
      SpeedSetting: 19,
      CCLanguageSetting: 20,
      Pip: 21,
      Fullscreen: 22,
      EndReplay: 23
   };
});
